var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourtreserve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 285,
    viewBox: "0 0 254 285",
    width: 254,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.7973 81.6484c13.6083-7.4768 29.2627-11.7767 45.9237-11.7767 14.031 0 25.723 2.2783 35.402 6.5462l17.18-19.9594c-15.914-7.6692-33.712-12.0654-52.582-12.0654-24.3258 0-46.9305 7.1879-65.8978 19.478z",
    fill: "#6cbe45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m197.305 134.182c3.865 9.787 6.008 20.441 6.008 31.576 0 48.358-39.818 87.699-88.763 87.699-48.9442 0-88.7624-39.341-88.7624-87.699 0-14.633 3.5077-28.431 9.5811-40.785l-15.5246-24.58c-12.50404 18.804-19.8441 41.234-19.8441 65.365 0 65.75 54.141 119.242 120.689 119.242 66.547 0 120.721-53.492 120.721-119.242 0-25.318-8.087-48.775-21.76-68.093z",
    fill: "#6cbe45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m27.9156 75.92 89.2824 141.416c1.332 2.246 4.644 2.246 5.976 0l129.848-212.17217c2.111-3.56188-2.794-7.05958-5.554-3.97903l-125.041 145.2992c-1.234 1.38-3.345 1.54-4.774.353l-84.5733-75.2811c-2.988-2.4066-7.1128 1.0911-5.1641 4.3641z",
    fill: "#212424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtreserve);
export default __webpack_public_path__ + "static/media/courtreserve.156c96b5e14b2ac29e6faad779afd28d.svg";
export { ForwardRef as ReactComponent };